"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNoteAttachmentDto = instanceOfNoteAttachmentDto;
exports.NoteAttachmentDtoFromJSON = NoteAttachmentDtoFromJSON;
exports.NoteAttachmentDtoFromJSONTyped = NoteAttachmentDtoFromJSONTyped;
exports.NoteAttachmentDtoToJSON = NoteAttachmentDtoToJSON;
exports.NoteAttachmentDtoToJSONTyped = NoteAttachmentDtoToJSONTyped;
/**
 * Check if a given object implements the NoteAttachmentDto interface.
 */
function instanceOfNoteAttachmentDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
function NoteAttachmentDtoFromJSON(json) {
    return NoteAttachmentDtoFromJSONTyped(json, false);
}
function NoteAttachmentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fileName': json['fileName'],
        'url': json['url'],
    };
}
function NoteAttachmentDtoToJSON(json) {
    return NoteAttachmentDtoToJSONTyped(json, false);
}
function NoteAttachmentDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fileName': value['fileName'],
        'url': value['url'],
    };
}
//# sourceMappingURL=NoteAttachmentDto.js.map